<script>
    export default {
        data() {
            return {
                errorText: '',
            }
        },
        computed: {
            providers() {return this.$store.getters.PROVIDERS},
            addData() {return this.$store.getters.PAG_GAME_ADD},
        },
        methods: {
            async changeData(event, fieldName, isCheckBox = false) {
                const data = isCheckBox === true ? 
                    event.target.checked : event.target.value;
                this.$store.commit('PAG_GAME_ADD_UPDATE', {
                    fieldName: fieldName, fieldValue: data,
                });
                this.errorText = await this.$store.dispatch('CHECK_GAME_ADD');
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input 
            @change="changeData($event, 'name')"
            :value="addData['name']"
            type="text"
            class="mb_10 mt_5 right_input"
        >
        <label>Provider:</label>
        <select
            @change="changeData($event, 'provider_id')"
            :value="addData['provider_id']"
            class="mb_10 mt_5 right_input"
        >
            <option :value="0">None</option>
            <option
                v-for="(providerValue, providerIndex) in providers" :key="providerIndex"
                :value="providerValue['id']"
            >{{ providerValue['name'] }}</option>
        </select>
        <label>
            <input 
                type="checkbox"
                :checked="addData['is_default']"
                @change="changeData($event, 'is_default', true)"
            >
            Default
        </label>
        
        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>